<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>A big thank you to everyone who purchased <em>Book 1</em>. I am truly grateful for the positive feedback that I have received.</p>
<p>Many thanks to all at Austin Macauley Publishers for all their hard work in getting my book, ‘Out the door.’</p>
<p>Thank you to everyone for the positive comments and the encouragement to<br/>
keep going.</p>
<p>And last, but not least, a huge thank you in advance to everyone who purchases <em>Book 2</em>; I hope you enjoy it.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?5814d461